import React from 'react'
import PropTypes from 'prop-types'
import Button from '@material-ui/core/Button'
import DialogActions from '@material-ui/core/DialogActions'
import DialogTitle from '@material-ui/core/DialogTitle'
import Typography from '@material-ui/core/Typography'
import Dialog from 'components/dialog'
import { useDialogTitleStyles } from 'components/dialog/use-dialog-title-styles'
import FileDownloadOutlinedIcon from 'components/material-symbol/icons/FileDownload'
import { useStyles } from './styles'
import { trackVirtualCoachingEvent, VIRTUAL_COACHING_EVENTS } from './analytics'
import { getDownloadUrl } from './utils'

// The same download dialog as "Download report" and "Export student list":
// shared `Dialog`, title and body text, Cancel and a contained primary
// Download. It is only used from the page itself, never on top of another
// dialog (the multi-video viewer downloads directly). The link is the same
// `fl_attachment` URL as before and opens in a new tab.
const DownloadVideoDialog = ({ open, onClose, video, trackedProps }) => {
  const dialogClasses = useDialogTitleStyles()
  const classes = useStyles()

  return (
    <Dialog
      isOpen={open}
      onClose={onClose}
      maxWidth="xs"
      fullWidth
      showCloseButton
      classes={{ paper: dialogClasses.dialogPaper }}
    >
      {({ closeDialog }) => (
        <>
          <DialogTitle
            disableTypography
            classes={{ root: dialogClasses.titleRoot }}
          >
            <Typography component="h2" className={dialogClasses.title}>
              Download video
            </Typography>
            <Typography className={dialogClasses.bodyText}>
              Save the golfer’s swing video to your device. It opens in a new
              tab and downloads automatically.
            </Typography>
          </DialogTitle>
          <DialogActions className={dialogClasses.actions}>
            <Button onClick={closeDialog} color="primary">
              Cancel
            </Button>
            <Button
              variant="contained"
              color="primary"
              component="a"
              href={getDownloadUrl(video.url)}
              download
              target="_blank"
              rel="noopener noreferrer"
              startIcon={<FileDownloadOutlinedIcon aria-hidden />}
              classes={{ label: classes.buttonLabel }}
              onClick={() => {
                trackVirtualCoachingEvent(
                  VIRTUAL_COACHING_EVENTS.DOWNLOAD_CLICKED,
                  trackedProps,
                )
                closeDialog()
              }}
            >
              Download
            </Button>
          </DialogActions>
        </>
      )}
    </Dialog>
  )
}

DownloadVideoDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  video: PropTypes.shape({ url: PropTypes.string.isRequired }).isRequired,
  trackedProps: PropTypes.object,
}

export default DownloadVideoDialog
